import React from "react";
import { observer } from "mobx-react";
import { CardPanel, Card, WidgetEmptyErrorPlaceholder, IconHighlight } from "@ann/web-components";
import FiSalesContent from "../../../../components/FiSalesContent/FiSalesContent";

const FISales = observer(({ contactId, selectedVehicle }) => {
  // Extraer vehicleUuid igual que en Garage
  const vehicleUuid = selectedVehicle 
    ? (selectedVehicle?.vehicleInformation?.vehicleUuid || selectedVehicle?.vehicleUuid || selectedVehicle?.id)
    : null;

  // Si no hay vehículo seleccionado, mostrar empty state
  if (!selectedVehicle) {
    return (
      <Card size='large'>
        <CardPanel isExpandable={false} openDefault={true}>
          <CardPanel.Content>
            <WidgetEmptyErrorPlaceholder
              icon="directionsCar"
              message="Select a vehicle to view FI Sales information"
              showButton={false}
              title="No Vehicle Selected"
            />
          </CardPanel.Content>
        </CardPanel>
      </Card>
    );
  }

  // Usar FiSalesContent (que ya maneja loading, error, y empty states)
  return (
    <Card size='large'>
      <CardPanel isExpandable={false}>
        <CardPanel.Header title='FI Sales'>
          <CardPanel.Header.LeftSlot>
            <IconHighlight icon='attachMoney' bgColor='Success' iconColor='Success' size='medium' />
          </CardPanel.Header.LeftSlot>
        </CardPanel.Header>
        <CardPanel.Content>
          <FiSalesContent 
            partyUuid={contactId}
            vehicleUuid={vehicleUuid}
          />
        </CardPanel.Content>
      </CardPanel>
    </Card>
  );
});

export default FISales; 